import * as Yup from "yup";

export function initialValuesThree(user, formData = {}) {
  const userData = { ...formData, ...user };

  return {
    contactPersons: [
      {
        name: user?.firstname + " " + user?.lastname || "",
        phone: userData?.phonePerson || "",
        email: user?.email || "",
      },
    ],
  };
}

export function validationSchemaTrhee() {
  return Yup.object({
    // Valida el objeto de dirección de factura
    contactPersons: Yup.array().of(
      Yup.object({
        name: Yup.string().required("El nombre es obligatorio"),
        phone: Yup.string().required("El teléfono es obligatorio"),
        email: Yup.string()
          .email("El email no es válido")
          .required("El email es obligatorio"),
      }),
    ),
  });
}
